module.exports = __webpack_public_path__ + "img/2.b2a7ee76.png";